import React from "react";
import { useTranslation } from "react-i18next";
import logo from "../../assets/logos/logo.png";

export const Footer: React.FC = () => {
  const { t } = useTranslation('common');

  return (
    <footer className="bg-foreground text-background py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <img
                src={logo}
                alt="Xentrix Flow Logo"
                className="w-8 h-8 invert"
              />
              <span className="text-xl font-bold">Xentrix Flow</span>
            </div>
            <p className="text-background/70 max-w-md mb-4">
              {t('landing.footer.description')}
            </p>
            <p className="text-background/70 text-sm">{t('landing.footer.copyright')}</p>
            <p className="text-background/70 text-sm mt-1">
              {t('landing.footer.builtBy')}{' '}
              <a
                href="https://nesolab.gr"
                target="_blank"
                rel="noopener"
                className="hover:text-background transition-colors"
              >
                Neso
              </a>
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4">{t('landing.footer.product')}</h4>
            <ul className="space-y-2 text-background/70">
              <li>
                <a href="#features" className="hover:text-background transition-colors">
                  {t('landing.footer.features')}
                </a>
              </li>
              <li>
                <a href="#platforms" className="hover:text-background transition-colors">
                  {t('landing.footer.integrations')}
                </a>
              </li>
              <li>
                <a href="#pricing" className="hover:text-background transition-colors">
                  {t('landing.footer.pricing')}
                </a>
              </li>
              <li>
                <span className="hover:text-background transition-colors cursor-pointer">
                  API
                </span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">{t('landing.footer.support')}</h4>
            <ul className="space-y-2 text-background/70">
              <li>
                <span className="hover:text-background transition-colors cursor-pointer">
                  {t('landing.footer.helpCenter')}
                </span>
              </li>
              <li>
                <span className="hover:text-background transition-colors cursor-pointer">
                  {t('landing.footer.contact')}
                </span>
              </li>
              <li>
                <span className="hover:text-background transition-colors cursor-pointer">
                  {t('landing.footer.privacyPolicy')}
                </span>
              </li>
              <li>
                <span className="hover:text-background transition-colors cursor-pointer">
                  {t('landing.footer.termsOfService')}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};
